import * as React from 'react'

import { Button, Link, Text } from 'main/ui'

import { CopyContainer } from './Confirmation.styles'
import PasswordForm from './PasswordForm'

interface IProps {
  onRequestClose: () => void
  showPasswordForm?: boolean
}

export default function Confirmation(props: IProps) {
  const { showPasswordForm, onRequestClose } = props

  return (
    <div>
      <CopyContainer>
        <Text>A representative will be in touch with you. In the meantime, check out our </Text>
        <Link target="_blank" to="/quality-safety">
          Quality & Safety
        </Link>
        <Text>.</Text>
      </CopyContainer>
      {showPasswordForm ? (
        <PasswordForm onRequestClose={onRequestClose} />
      ) : (
        <Button full onClick={() => onRequestClose()}>
          Done
        </Button>
      )}
    </div>
  )
}
